// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".CoralNewUserDiscountButton-cls1___55b153ac9bc2eab77e6{/*!*/}.CoralNewUserDiscountButton-cls2___5b142f247abc7dd4c19{display:flex;flex-direction:column;align-items:center;justify-content:center;height:36px;padding:0 18px;cursor:pointer;flex-shrink:0;margin-right:12px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "CoralNewUserDiscountButton-cls1___55b153ac9bc2eab77e6",
	"cls2": "CoralNewUserDiscountButton-cls2___5b142f247abc7dd4c19 CoralNewUserDiscountButton-cls1___55b153ac9bc2eab77e6"
};
export default ___CSS_LOADER_EXPORT___;
